import { Component } from '@angular/core';

@Component({
  selector: 'app-animated-logo',
  templateUrl: './animated-logo.component.html',
  styleUrls: ['./animated-logo.component.sass'],
})
export class AnimatedLogoComponent {}
